// Externe Bibliotheken
import React, { Component } from 'react';
import * as ReactSlickModule from 'react-slick';

// Interne Module
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Styles
import 'react-lazy-load-image-component/src/effects/blur.css';
import './slider.scss';

const Slider = ReactSlickModule.default?.default;

class ExcursionSlider extends Component {
    render() {
        return (
            <Slider {...this.props.settings}>
                {this.props.images.map((v, i) => {
                    return (
                        <LazyLoadImage
                            wrapperClassName="lazy-load-background"
                            key={i}
                            src={v}
                            alt=""
                            effect={this.props.effect !== undefined ? this.props.effect : 'blur'}
                        />
                    );
                })}
            </Slider>
        );
    }
}

export default ExcursionSlider;
